import { BorderSide } from "~/features/andon/andon.types";

import AndonCellEditPopover from "./AndonCellEditPopover";
import AndonMultiCellBorderPopover from "./AndonMultiCellBorderPopover";
import AndonTextLabelEditMenu from "./AndonTextLabelEditMenu";

type AndonCellEditTriageProps = {
  advanced: boolean;
  isMultiCellSelection: boolean;
  isTextLabelSelected: boolean;
  isEditCellMenuOpen: boolean;
  editCellMenuAnchorPosition: { left: number; top: number } | null;
  selectedGridIndex: string | null;
  targetCellSides: BorderSide[];
  targetCellColor: string;
  pickerSelectionTitle?: string;
  workingWorkstationIds: string[];
  siteFcId?: string;
  closeEditCellMenu: (
    event?: object | React.SyntheticEvent | Event | null,
    reason?: string
  ) => void;
  handleSetCellBorder: (sides: BorderSide[], color: string) => void;
  handleEditTextLabel: (layoutItemId: string) => void;
  handleDeleteTextLabel: (layoutItemId: string) => void;
  selectWorkstation: (workstationId: string | null) => void;
  handlePickWorkstation: (
    workstationId: string,
    fulfillmentCenterId?: string
  ) => void;
  openAddTextLabelModal: () => void;
};

export default function AndonCellEditTriage({
  advanced,
  isMultiCellSelection,
  isTextLabelSelected,
  isEditCellMenuOpen,
  editCellMenuAnchorPosition,
  selectedGridIndex,
  targetCellSides,
  targetCellColor,
  pickerSelectionTitle,
  workingWorkstationIds,
  siteFcId,
  closeEditCellMenu,
  handleSetCellBorder,
  handleEditTextLabel,
  handleDeleteTextLabel,
  selectWorkstation,
  handlePickWorkstation,
  openAddTextLabelModal
}: AndonCellEditTriageProps) {
  const anchorPosition = editCellMenuAnchorPosition ?? undefined;

  if (advanced && isMultiCellSelection) {
    return (
      <AndonMultiCellBorderPopover
        open={isEditCellMenuOpen}
        anchorPosition={anchorPosition}
        cellBorderSides={targetCellSides}
        cellBorderColor={targetCellColor}
        onClose={closeEditCellMenu}
        onSetCellBorder={handleSetCellBorder}
      />
    );
  }

  if (isTextLabelSelected && !isMultiCellSelection) {
    return (
      <AndonTextLabelEditMenu
        open={isEditCellMenuOpen}
        anchorPosition={anchorPosition}
        layoutItemId={selectedGridIndex!}
        advanced={advanced}
        cellBorderSides={targetCellSides}
        cellBorderColor={targetCellColor}
        onClose={closeEditCellMenu}
        onEdit={handleEditTextLabel}
        onDelete={handleDeleteTextLabel}
        onSetCellBorder={handleSetCellBorder}
      />
    );
  }

  return (
    <AndonCellEditPopover
      open={isEditCellMenuOpen && !isTextLabelSelected && !isMultiCellSelection}
      anchorPosition={editCellMenuAnchorPosition}
      onClose={closeEditCellMenu}
      canRemove={Boolean(selectedGridIndex)}
      selectionTitle={pickerSelectionTitle}
      showAddTextLabel={Boolean(
        editCellMenuAnchorPosition && !selectedGridIndex
      )}
      workingWorkstationIds={workingWorkstationIds}
      siteFcId={siteFcId}
      cellBorderSides={advanced ? targetCellSides : undefined}
      cellBorderColor={advanced ? targetCellColor : undefined}
      onRemove={() => selectWorkstation(null)}
      onSelectWorkstation={handlePickWorkstation}
      onAddTextLabel={openAddTextLabelModal}
      onSetCellBorder={advanced ? handleSetCellBorder : undefined}
    />
  );
}
